import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import { getPublicSiteSettings } from '../services/api';
import './Historique.css';

const DEFAULT_TIMELINE = [
  { year: '2015', title: 'Fondation', text: 'MUTU NDE ESPOIR ASBL a été fondée à Kisangani avec pour mission d\'apporter un soutien solidaire à la communauté.' },
  { year: '2016-2018', title: 'Développement des Services', text: 'Pendant cette période, l\'organisation a développé ses premiers services de prise en charge santé et a établi des partenariats avec des centres de santé locaux.' },
  { year: '2019-2020', title: 'Expansion des Services', text: 'L\'organisation a étendu ses services pour inclure l\'assistance juridique et le soutien social.' },
  { year: '2021-2022', title: 'Digitalisation', text: 'MUTU NDE ESPOIR ASBL a entamé sa transformation digitale avec le développement d\'une plateforme en ligne.' },
  { year: '2023-2024', title: 'Modernisation et Croissance', text: 'L\'organisation a modernisé ses systèmes de gestion avec cartes à code-barres, application mobile et suivi en temps réel.' },
  { year: '2025', title: 'Aujourd\'hui', text: 'MUTU NDE ESPOIR ASBL continue d\'évoluer et de s\'adapter aux besoins de la communauté.' }
];

const DEFAULT_ACHIEVEMENTS = [
  { icon: '👥', title: 'Membres Actifs', text: 'Plus de 5000 membres bénéficient de nos services' },
  { icon: '🏥', title: 'Centres Partenaires', text: 'Partenariats avec plus de 20 centres de santé' },
  { icon: '⚖️', title: 'Assistance Juridique', text: 'Plus de 1000 cas traités avec succès' },
  { icon: '🤝', title: 'Impact Social', text: 'Amélioration de la qualité de vie de la communauté' }
];

const Historique = () => {
  const [siteSettings, setSiteSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPublicSiteSettings()
      .then((res) => res?.data && typeof res.data === 'object' && setSiteSettings(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const title = siteSettings?.historique_title ?? 'Notre Historique';
  const subtitle = siteSettings?.historique_subtitle ?? 'Un parcours de solidarité et d\'engagement';
  const timeline = Array.isArray(siteSettings?.historique_timeline) && siteSettings.historique_timeline.length > 0
    ? siteSettings.historique_timeline
    : DEFAULT_TIMELINE;
  const achievementsTitle = siteSettings?.historique_achievements_title ?? 'Nos Réalisations';
  const achievements = Array.isArray(siteSettings?.historique_achievements) && siteSettings.historique_achievements.length > 0
    ? siteSettings.historique_achievements
    : DEFAULT_ACHIEVEMENTS;
  const siteName = siteSettings?.site_name ?? 'MUTU NDE ESPOIR ASBL';
  const siteLogo = siteSettings?.site_logo ?? '/logo.png';

  if (loading) {
    return (
      <div className="historique-page">
        <Navigation siteName={siteName} siteLogo={siteLogo} />
        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
          <div className="spinner" style={{ margin: '0 auto 20px' }}></div>
          <p>Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="historique-page">
      <Navigation siteName={siteName} siteLogo={siteLogo} />
      
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">{title}</h1>
          <p className="page-subtitle">{subtitle}</p>
        </div>
      </div>

      <div className="container">
        <section className="historique-content">
          <div className="timeline">
            {timeline.filter(item => item && (item.year || item.title || item.text)).map((item, i) => (
              <div key={i} className="timeline-item">
                <div className="timeline-year">{item.year || ''}</div>
                <div className="timeline-content">
                  <h3>{item.title || ''}</h3>
                  <p>{item.text || ''}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="achievements-section">
            <h2>{achievementsTitle}</h2>
            <div className="achievements-grid">
              {achievements.filter(a => a && (a.icon || a.title || a.text)).map((item, i) => (
                <div key={i} className="achievement-card">
                  <div className="achievement-icon">{item.icon || '•'}</div>
                  <h3>{item.title || ''}</h3>
                  <p>{item.text || ''}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      
      <footer className="presentation-footer">
        <div className="container">
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} {siteName}. Tous droits réservés.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Historique;

